module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/bad/pull_items-69c96627bb4827397aff0dbfd0427850.png";